"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_COLOR = exports.BORDER_RADIUS = void 0;
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
/* eslint-disable max-len */

var BORDER_RADIUS = {
  LEFT: "".concat(_theme.default.borderRadius.normal, " ").concat(_theme.default.space.none, " ").concat(_theme.default.space.none, " ").concat(_theme.default.borderRadius.normal),
  MIDDLE: "".concat(_theme.default.space.none, " ").concat(_theme.default.borderRadius.normal, " ").concat(_theme.default.borderRadius.normal, " ").concat(_theme.default.space.none),
  RIGHT: "".concat(_theme.default.space.none)
};
exports.BORDER_RADIUS = BORDER_RADIUS;
var DEFAULT_COLOR = {
  BACKGROUND_COLOR: 'default',
  BORDDER_COLOR: 'greyLight'
};
exports.DEFAULT_COLOR = DEFAULT_COLOR;